const PASTEL_COLORS = new Set([
  '#DCEFF8',
  '#E6F3FA',
  '#DCEEE3',
  '#E6F5EF',
  '#EAE4F8',
  '#F8E6EC',
  '#FCEBDF',
  '#F9F4DE',
  '#EEF1F4',
  '#F5F1EA',
]);

export { PASTEL_COLORS };
export const getContrastTextColor = (hexColor: string): string => {
  const normalized = hexColor.startsWith('#') ? hexColor : `#${hexColor}`;
  if (PASTEL_COLORS.has(normalized)) {
    return '#000000';
  }
  const hex = normalized.replace('#', '');
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.55 ? '#000000' : '#ffffff';
};

/**
 * For headings on a white background: use the accent color itself if it's
 * readable on white (vivid/green), otherwise force black (pastel/high-luminance).
 */
export const getHeadingColor = (hexColor: string): string => {
  const normalized = hexColor.startsWith('#') ? hexColor : `#${hexColor}`;
  if (PASTEL_COLORS.has(normalized)) {
    return '#000000';
  }
  const hex = normalized.replace('#', '');
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  // Low luminance = vivid color, use as-is for heading on white background
  return luminance < 0.5 ? normalized : '#000000';
};
